import React from "react"
import { Helmet } from "react-helmet"
import Layout from "../../../components/Layout"
import Header from "../../../components/Header"
import CaseStudy, {
  CASE_STUDY_TYPES,
} from "../../../components/case-study/CaseStudy"
import ThumbnailImage from "../../../images/thumbnails/mercedes_benz.png"

export function Index() {
  return (
    <Layout
      title="Mercedes-Benz EQE SUV Exclusive Event Success with Premagic AI Photos"
      description="Coastal Star Mercedes-Benz used Premagic for an exclusive EQE SUV showcase, delivering premium and personalized photo experiences to VIP guests for a luxury automotive launch."
      metaImage={ThumbnailImage}
      keywords={[
        "Mercedes-Benz case study, luxury car event photos, EQE SUV showcase, automotive event technology, premium car events, luxury vehicle launches, Mercedes dealership events, automotive photo sharing, car launch photography, luxury brand events, automotive marketing photos, premium car showcase, vehicle launch management, luxury automotive events, car dealership technology",
      ]}
      breadcrumbs={[
        { name: "Home", url: "/" },
        { name: "Case Studies", url: "/case-study/" },
        { name: "Mercedes-Benz", url: "/case-study/mercedes-benz/" },
      ]}
    >
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            "headline": "Mercedes-Benz EQE SUV Exclusive Event Success with Premagic AI Photos",
            "description": "Coastal Star Mercedes-Benz used Premagic for an exclusive EQE SUV showcase, delivering premium and personalized photo experiences to VIP guests for a luxury automotive launch.",
            "image": "https://premagic.com" + ThumbnailImage,
            "author": {
              "@type": "Organization",
              "name": "Premagic",
            },
            "publisher": {
              "@type": "Organization",
              "name": "Premagic",
              "logo": {
                "@type": "ImageObject",
                "url": "https://premagic.com/icons/icon-144x144.png",
              },
            },
            "datePublished": "2024-01-15",
            "dateModified": "2025-01-15",
          })}
        </script>
      </Helmet>
      <Header />
      <CaseStudy type={CASE_STUDY_TYPES.MERCEDES_BENZ} />
    </Layout>
  )
}

export default Index
